import 'flickity/dist/flickity.pkgd.min.js';
import 'flickity-fullscreen/fullscreen.js';
import 'flickity-imagesloaded/flickity-imagesloaded.js';

jQuery(document).ready(function() {
  
    var $gallery = $('.as-seen-in-gallery').flickity({
      lazyLoad: false,
      imagesLoaded: true,
      wrapAround: false,
      contain: true,
      freeScroll: true,
      accessibility: true,
      prevNextButtons: true,
      pageDots: false,
      setGallerySize: true,
      cellAlign: 'left',
      fullscreen: true,
      adaptiveHeight: false,
      /*arrowShape: {
        x0: 10,
        x1: 60,
        y1: 50,
        x2: 60,
        y2: 45,
        x3: 15,
      },*/
    });
    $gallery.flickity();

});



// WEBPACK FOOTER //
// ./scripts/single-as-seen-in.js